import {useMutation} from "@tanstack/react-query";

import {deleteSupplierOfferMutationOptions} from "./delete-supplier-offer.mutation-options";

export function useDeleteSupplierOffer() {
  return useMutation(deleteSupplierOfferMutationOptions());
}
